import { useState } from "react";
import { negate } from "@/libs/utils/predicate/negate";

type SetBooleanState = {
  (update: boolean | ((old: boolean) => boolean)): void;
  toggle: () => void;
  toTrue: () => void;
  toFalse: () => void;
};

export function useBooleanState(initial = false) {
  const [state, setState] = useState<boolean>(Boolean(initial));

  function setBooleanState(update: boolean | ((old: boolean) => boolean)) {
    setState((old) =>
      typeof update === "function" ? Boolean(update(old)) : Boolean(update)
    );
  }

  const setBooleanStateWithShortcuts = setBooleanState as SetBooleanState;
  setBooleanStateWithShortcuts.toggle = () => setState(negate);
  setBooleanStateWithShortcuts.toTrue = () => setState(true);
  setBooleanStateWithShortcuts.toFalse = () => setState(false);

  return [state, setBooleanStateWithShortcuts] as const;
}
